import { useStateValue } from "../context/StateValueContext";
import { hasPermission } from "../functions/permissionUtils";
import { PERMISSIONS } from "../constants/permissions";

export type VampRatesAccess = "visible" | "hidden" | "loading" | "error";

// Clients default to hidden until settings resolve (vampRatesEnabled === null),
// so the VAMP tab never flashes before we know whether the company is gated.
// "error" means the settings fetch failed and the answer is unknowable without a retry.
export function useVampRatesAccess(): VampRatesAccess {
  const [{ user, vampRatesEnabled, companySettingsFailed }] = useStateValue();
  if (hasPermission(user, PERMISSIONS.VAMP_RATES_ALL)) return "visible";
  if (!hasPermission(user, PERMISSIONS.VAMP_RATES_OWN)) return "hidden";
  if (companySettingsFailed) return "error";
  if (vampRatesEnabled === null) return "loading";
  return vampRatesEnabled ? "visible" : "hidden";
}

export function useVampRatesVisible(): boolean {
  return useVampRatesAccess() === "visible";
}
